<template>
  <div class="relative">
    <client-only>
      <carousel
        ref="carousel"
        class="product-carousel relative"
        :autoplay="false"
        :autoplay-timeout="6000"
        :autoplay-hover-pause="true"
        :loop="true"
        :per-page="1"
        :pagination-enabled="true"
        :navigation-enabled="true"
        :navigation-prev-label="prevIcon"
        :navigation-next-label="nextIcon"
        :pagination-padding="5"
        :max-pagination-dot-count="images.length <= 10 ? images.length : 10"
        pagination-position="bottom-overlay"
        pagination-color="#c8cfdb"
        pagination-active-color="#3c5174"
      >
        <slide v-for="(image, index) in images" :key="index">
          <AppCarouselSlide class="">
            <img
              class="special-img-shop"
              :src="image"
              alt="product image"
              @click="$refs.lightbox.show(index)"
            />
          </AppCarouselSlide>
        </slide>
        <Lightbox ref="lightbox" :images="images" />
      </carousel>
    </client-only>
  </div>
</template>

<script>
import Lightbox from '~/components/Lightbox'
import AppCarouselSlide from '~/components/carousel/AppCarouselSlide'

export default {
  components: {
    Lightbox,
    AppCarouselSlide,
  },

  props: {
    images: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      prevIcon:
        '<svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path d="M2.504 6.112l3.82-4.115a.62.62 0 0 0 .164-.426.621.621 0 0 0-.163-.425L5.99.786a.535.535 0 0 0-.79 0l-4.55 4.9a.621.621 0 0 0-.162.426c0 .162.057.313.163.427l4.545 4.895a.535.535 0 0 0 .79 0l.334-.36a.636.636 0 0 0 0-.851l-3.816-4.11z" fill="#FFF" fill-rule="nonzero"/></svg>',
      nextIcon:
        '<svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg"><path d="M4.496 6.112L.676 1.997a.62.62 0 0 1-.164-.426c0-.16.058-.312.163-.425l.335-.36a.535.535 0 0 1 .79 0l4.55 4.9a.621.621 0 0 1 .162.426.621.621 0 0 1-.163.427l-4.545 4.895a.535.535 0 0 1-.79 0l-.334-.36a.636.636 0 0 1 0-.851l3.816-4.11z" fill="#FFF" fill-rule="nonzero"/></svg>',
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .product-carousel {
  .VueCarousel-dot {
    &:focus {
      @apply outline-none;
    }
  }

  .VueCarousel-navigation-button {
    top: calc(50%);
    transform: translateY(-50%) translateX(0%);
    width: 36px;
    height: 36px;

    @apply rounded bg-grey;

    &:hover {
      @apply bg-grey-darker;
    }

    &:focus {
      @apply outline-none;
    }
  }

  .VueCarousel-navigation-next {
    right: 15px;

    > svg {
      margin-right: -2px;
    }
  }

  .VueCarousel-navigation-prev {
    left: 15px;

    > svg {
      margin-left: -2px;
    }
  }
}
</style>
